// import React, { useState, useEffect } from "react";
// import useRouting from "../hooks/useRouting";
// import usePageTracking from "../hooks/usePageTracking";
// import environment from "../environment";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { getHeaders, getStorage, handleApiError } from "../utils/apiUtils";
// import Header from "./Header";
// import LenderLoadingScreen from "./LenderLoadingScreen";
// import "./EmploymentDetails.css";
// import employment_Detail from "../assets/images/employment_Detail.svg";


// const capitalizeWord = (value = "") =>
// value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "";


// const formatIndianNumber = (value = "") => {
// if (!value) return "";
// const numberValue = Number(value);
// if (Number.isNaN(numberValue)) return "";
// // eslint-disable-next-line no-undef
// return new Intl.NumberFormat("en-IN").format(numberValue);
// };


// const EmploymentDetails = () => {
// // Company Details State
// const [companyName, setCompanyName] = useState("");
// const [address, setAddress] = useState("");
// const [addressLine, setAddressLine] = useState("");
// const [pinCode, setPinCode] = useState("");
// const [state, setState] = useState("");
// const [city, setCity] = useState("");
// const [area, setArea] = useState("");
// const [pincodeStatus, setPincodeStatus] = useState("");


// // Employment Details State
// const [employmentType, setEmploymentType] = useState("");


// // Income Details State
// const [incomeType, setIncomeType] = useState("");
// const [monthlyIncome, setMonthlyIncome] = useState("");


// // Loading and error states
// const [isLoading, setIsLoading] = useState(false);
// const [isLenderLoading, setIsLenderLoading] = useState(false);
// const [apiError, setApiError] = useState("");
// //const [sendOrAssignLenderFailed, setSendOrAssignLenderFailed] = useState(false);
// //const [treatmentDetails, setTreatmentDetails] = useState(true);
// //const [lenderDetail, setLenderDetail] = useState(null);


// const { navigateWithContext, navigateBack } = useRouting();

// // Track page visit
// usePageTracking("employment-details");


// useEffect(() => {
// fetchEmploymentDetails();
// //assignLender();
// }, []);


// // Watch for pin code changes and auto-fill state/city
// useEffect(() => {
// const fetchLocation = async () => {
// if (pinCode && pinCode.length === 6) {
// setPincodeStatus("Please wait fetching state & city ...");
// const locationData = await fetchLocationFromPinCode(pinCode);
// if (locationData) {
// setState(capitalizeWord(locationData.state));
// setCity(capitalizeWord(locationData.city));
// setArea(capitalizeWord(locationData.area));
// setPincodeStatus("");
// } else {
// setPincodeStatus("Failed to fetch city/state");
// }
// } else {
// setState("");
// setCity("");
// setPincodeStatus("");
// }
// };


// // Debounce the API call to avoid too many requests
// const timeoutId = setTimeout(fetchLocation, 500);
// return () => clearTimeout(timeoutId);
// }, [pinCode]);


// // Fetch employment details to prefill form
// const fetchEmploymentDetails = async () => {
// try {
// const applicationId = getStorage("application_id");
// if (!applicationId) {
// console.error("Application ID not found in localStorage");
// return;
// }


// const endpoint = `${environment.apiurl}applications/${applicationId}/employment_details/`;
// const response = await axios.get(endpoint, { headers: getHeaders() });

// if (response?.data?.msg) {
// const employmentData = response.data.msg;

// // Prefill company details
// if (employmentData.company_name) setCompanyName(employmentData.company_name);
// if (employmentData.employment_type) setEmploymentType(employmentData.employment_type.toLowerCase());
// if (employmentData.monthly_income) setMonthlyIncome(employmentData.monthly_income.toString());
// if (employmentData.medium_of_salary) setIncomeType(employmentData.medium_of_salary.toLowerCase());

// // Prefill company address if available
// if (employmentData.address_line_1) setAddress(employmentData.address_line_1);
// if (employmentData.address_line_2) setAddressLine(employmentData.address_line_2);
// if (employmentData.area) setArea(employmentData.area.toLowerCase());
// if (employmentData.pincode) setPinCode(employmentData.pincode);
// if (employmentData.city) setCity(capitalizeWord(employmentData.city));
// if (employmentData.state) setState(capitalizeWord(employmentData.state));
// }
// } catch (error) {
// console.error("Error fetching employment details:", error);
// // Don't show error to user for prefill failures
// }
// };


// // Assign lender API call
// const assignLender = async () => {
// try {
// const applicationId = getStorage("application_id");
// if (!applicationId) {
// console.error("Application ID not found in localStorage");
// return;
// }


// const payload = {
// data: "",
// };


// const response = await axios.post(
// `${environment.apiurl}applications/${applicationId}/assign_lender/`,
// payload,
// { headers: getHeaders() }
// );


// if (response?.data?.msg) {
// // setLenderDetail(response.data.msg);
// localStorage.setItem(
// "lenderDetail",
// JSON.stringify(response.data.msg?.lender)
// );
// console.log('response.data.msg', response.data.msg)
// await sendToLenderCall();


// }
// } catch (err) {
// console.error("Error in assignLender:", err);
// Swal.fire({
// icon: "error",
// title: "Error assigning lender",
// text: "An error occurred while assigning a lender. Please try again later.",
// showConfirmButton: false,
// timer: 3000,
// });
// }
// };


// // API call to submit employment details
// const submitEmploymentDetails = async () => {
// const applicationId = getStorage("application_id");
// if (!applicationId) {
// throw new Error("Application ID not found");
// }


// const payload = {
// data: [
// {
// model_name: "personal_company_address",
// field: [
// {
// key: "address_line_1",
// value: address,
// },
// {
// key: "address_line_2",
// value: addressLine,
// },
// {
// key: "landmark",
// value: area,
// },
// {
// key: "pincode",
// value: pinCode,
// },
// {
// key: "city",
// value: city,
// },
// {
// key: "state",
// value: state,
// },
// ],
// },
// {
// model_name: "personal",
// field: [
// {
// key: "company_name",
// value: companyName,
// },
// {
// key: "employment_type",
// value: employmentType,
// },
// {
// key: "monthly_income",
// value: parseInt(monthlyIncome) || 0,
// },
// {
// key: "medium_of_salary",
// value: incomeType,
// },
// ],
// },
// ],
// };


// const response = await axios.post(
// `${environment.apiurl}applications/${applicationId}/save/data/`,
// payload,
// { headers: getHeaders() }
// );
// assignLender();


// return response.data;
// };


// // Send to lender API call
// // const sendToLenderCall = async () => {
// // setIsLenderLoading(true);

// // // Set a timeout to automatically turn off loading after 10 seconds
// // const loadingTimeout = setTimeout(() => {
// // setIsLenderLoading(false);
// // }, 10000);

// // try {
// // const applicationId = getStorage("application_id");
// // if (!applicationId) {
// // clearTimeout(loadingTimeout); // Clear the timeout if there's an error
// // throw new Error("Application ID not found");
// // }


// // const payload = {
// // data: "",
// // };


// // const response = await axios.post(
// // `${environment.apiurl}applications/${applicationId}/send_to_lender/`,
// // payload,
// // { headers: getHeaders() }
// // );


// // console.log(response);
// // setIsLenderLoading(false);
// // navigateWithContext("lender-success");

// // if (response?.data?.msg?.url) {
// // // If URL is provided, redirect to external URL
// // localStorage.setItem("redirectURL", response.data.msg.url)
// // }


// // } catch (error) {
// // console.error("Error sending to lender:", error);
// // clearTimeout(loadingTimeout); // Clear the timeout in case of error
// // setIsLenderLoading(false);
// // setApiError("Failed to send application to lender");

// // if (error?.response?.data?.msg?.data?.code === 100) {
// // setIsLoading(false);
// // setTreatmentDetails(false);
// // setSendOrAssignLenderFailed(true);
// // } else {
// // setTreatmentDetails(true);
// // setIsLoading(false);
// // }
// // throw error;
// // }
// // };



// // Send to lender API call
// const sendToLenderCall = async () => {
// setIsLenderLoading(true);


// const start = Date.now(); // Start 10-sec timer here


// try {
// const applicationId = getStorage("application_id");
// if (!applicationId) {
// throw new Error("Application ID not found");
// }


// const payload = {
// data: "",
// };


// // Actual API call
// const response = await axios.post(
// `${environment.apiurl}applications/${applicationId}/send_to_lender/`,
// payload,
// { headers: getHeaders() }
// );


// console.log(response);


// // Calculate remaining time to complete 10 seconds
// const elapsed = Date.now() - start;
// const remaining = 10000 - elapsed;


// // Always wait full 10 sec before moving ahead
// setTimeout(() => {
// setIsLenderLoading(false);


// // Navigate AFTER loader hides
// navigateWithContext("lender-success");


// if (response?.data?.msg?.url) {
// localStorage.setItem("redirectURL", response.data.msg.url);
// }
// }, remaining > 0 ? remaining : 0);


// } catch (error) {
// console.error("Error sending to lender:", error);


// const elapsed = Date.now() - start;
// const remaining = 10000 - elapsed;


// // Even on error, keep loader for full 10 seconds
// setTimeout(() => {
// setIsLenderLoading(false);
// setApiError("Failed to send application to lender");


// if (error?.response?.data?.msg?.data?.code === 100) {
// setIsLoading(false);
// //setTreatmentDetails(false);
// //setSendOrAssignLenderFailed(true);
// } else {
// //setTreatmentDetails(true);
// setIsLoading(false);
// }
// }, remaining > 0 ? remaining : 0);
// }
// };



// const handleContinue = async () => {
// const employmentData = {
// companyDetails: {
// name: companyName,
// address: address,
// addressLine: addressLine,
// pinCode: pinCode,
// state: state,
// city: city,
// area: area,
// },
// employmentDetails: {
// type: employmentType,
// },
// incomeDetails: {
// type: incomeType,
// monthlyIncome: monthlyIncome,
// },
// };


// const isCompanyDetailsValid = companyName && address && pinCode && state && city && area;
// const isEmploymentDetailsValid = employmentType;
// const isIncomeDetailsValid = incomeType && monthlyIncome;


// if (isCompanyDetailsValid && isEmploymentDetailsValid && isIncomeDetailsValid) {
// setIsLoading(true);
// setApiError("");


// try {
// // Submit employment details to API
// await submitEmploymentDetails();


// // Save to localStorage after successful API call
// localStorage.setItem("employmentDetails", JSON.stringify(employmentData));

// // Call sendToLenderCall after successful employment details submission

// } catch (error) {
// console.error("Error submitting employment details:", error);
// const errorMessage = handleApiError(error);
// setApiError(errorMessage);
// } finally {
// setIsLoading(false);
// }
// }
// };


// const handleBack = () => {
// // Use new routing
// navigateBack("address-details");
// };


// const handleMonthlyIncomeChange = (value) => {
// const sanitizedValue = value.replace(/\D/g, "");
// setMonthlyIncome(sanitizedValue);
// };


// // Function to fetch location data from postal API
// // const fetchLocationFromPinCode = async (pinCode) => {
// // if (!pinCode || pinCode.length !== 6) {
// // return {
// // state: "",
// // city: "",
// // area: "",
// // };
// // }
// // try {
// // const response = await axios.get(
// // `https://api.postalpincode.in/pincode/${pinCode}`
// // );


// // if (
// // response.data &&
// // response.data[0] &&
// // response.data[0].Status === "Success"
// // ) {
// // const postOffices = response.data[0].PostOffice;
// // if (postOffices && postOffices.length > 0) {
// // const firstOffice = postOffices[0];
// // return {
// // state: firstOffice.State,
// // city: firstOffice.District,
// // };
// // }
// // } else {
// // return {
// // state: "",
// // city: "",
// // };
// // }
// // } catch (error) {
// // console.error("Error fetching location from pin code:", error);
// // return null;
// // }
// // };



// const fetchLocationFromPinCode = async (pinCode) => {
// if (!pinCode || pinCode.length !== 6) {
// return { state: "", city: "", area: "" };
// }


// try {
// const response = await axios.get(
// `https://api.postalpincode.in/pincode/${pinCode}`
// );


// if (
// response.data &&
// response.data[0] &&
// response.data[0].Status === "Success"
// ) {
// const office = response.data[0].PostOffice?.[0];
// console.log('office', office);


// return {
// state: office.State,
// city: office.District,
// area: office.Name, // ← Area/Locality
// };
// }


// return { state: "", city: "", area: "" };
// } catch (error) {
// console.error("Error fetching location from pin code:", error);
// return null;
// }
// };


// const employmentTypes = [{key :"Salaried", value: "s"}, { key :"Self Employed" , value: "e"}, { key :"Business Owner", value: "b"}, { key :"Freelancer", value: "f"}];
// const incomeTypes = [{key :"Bank Account", value: "received_in_bank_account"}, { key :"Cash" , value: "cash"}, { key :"Cheque", value: "cheque"}, { key :"Online Transfer", value: "ot"}];


// const isFormValid =
// companyName && address && pinCode && state && city && area &&
// employmentType && incomeType && monthlyIncome;


// return (
// <>
// {/* Show lender loading screen when sending to lender */}
// {isLenderLoading && <LenderLoadingScreen />}

// <div className="loan-container">
// <Header showBackButton={true} onBackClick={handleBack} />


// <div className="main-content">
// <div className="hero-section">
// <div className="hero-icon">
// <img src={employment_Detail} alt="Employment Details" />
// </div>
// <h1 className="hero-title">
// Please share your
// <br />
// employment details
// </h1>
// </div>


// <div className="form-section">
// {/* Company Details Section */}
// <div className="employment-detail-container">
// <h2 className="section-title">Company Details</h2>
// <div className="employment-detail-form-group">
// <div className="form-group-container">
// <label className="form-label">Company Name <span className="text-red-500">*</span></label>
// <input
// type="text"
// className="form-input"
// placeholder="AyushPay"
// value={companyName}
// onChange={(e) => setCompanyName(e.target.value)}
// />
// </div>


// <div className="form-group-container">
// <label className="form-label">Address <span className="text-red-500">*</span></label>
// <input
// type="text"
// className="form-input"
// placeholder="AVLS Tower"
// value={address}
// onChange={(e) => setAddress(e.target.value)}
// />
// </div>


// <div className="form-group-container">
// <label className="form-label">Address 1</label>
// <input
// type="text"
// className="form-input"
// placeholder="Address Line 2"
// value={addressLine}
// onChange={(e) => setAddressLine(e.target.value)}
// />
// </div>


// <div className="form-group-container">
// <label className="form-label">Pin Code <span className="text-red-500">*</span></label>
// <div className="pincode-input-container">
// <input
// type="text"
// className="form-input"
// placeholder="122003"
// value={pinCode}
// onChange={(e) => {
// const val = e.target.value;
// setPinCode(val);
// if (val.length !== 6) {
// setPincodeStatus("");
// }
// }}
// maxLength={6}
// />
// {pincodeStatus && (
// <p
// style={{
// color: "#216fed",
// fontSize: "12px",
// marginTop: "4px",
// textAlign: "left",
// alignSelf: "flex-start",
// }}
// >
// {pincodeStatus}
// </p>
// )}
// </div>
// </div>


// <div className="form-group-container">
// <label className="form-label">State <span className="text-red-500">*</span></label>
// <input
// type="text"
// className="form-input"
// placeholder="State"
// value={state}
// onChange={(e) => setState(capitalizeWord(e.target.value))}
// />
// </div>


// <div className="form-group-container">
// <label className="form-label">City <span className="text-red-500">*</span></label>
// <input
// type="text"
// className="form-input"
// placeholder="City"
// value={city}
// onChange={(e) => setCity(capitalizeWord(e.target.value))}
// />
// </div>


// <div className="form-group-container">
// <label className="form-label">Area, Locality <span className="text-red-500">*</span></label>
// <input
// type="text"
// className="form-input"
// placeholder="Area"
// value={area}
// onChange={(e) => setArea(capitalizeWord(e.target.value))}


// />
// </div>
// </div>
// </div>


// {/* Employment Details Section */}
// <div className="employment-detail-container">
// <h2 className="section-title">Employment Details</h2>
// <div className="employment-detail-form-group">
// <div className="form-group-container">
// <label className="form-label">Employment Type <span className="text-red-500">*</span></label>
// <select
// className="form-select"
// value={employmentType}
// onChange={(e) => setEmploymentType(e.target.value)}
// >
// <option value="">Select Employment Type</option>
// {employmentTypes.map((type, index) => (
// <option key={index} value={type.value}>
// {type.key}
// </option>
// ))}
// </select>
// </div>
// </div>
// </div>


// {/* Income Details Section */}
// <div className="employment-detail-container">
// <h2 className="section-title" style={{ color: "#4A90E2", marginBottom: "16px" }}>Income Details</h2>
// <div className="employment-detail-form-group">
// <div className="form-group-container">
// <label className="form-label">Salary credited in <span className="text-red-500">*</span></label>
// <select
// className="form-select"
// value={incomeType}
// onChange={(e) => setIncomeType(e.target.value)}
// >
// <option value="">Select Income Type</option>
// {incomeTypes.map((type, index) => (
// <option key={index} value={type.value}>
// {type.key}
// </option>
// ))}
// </select>
// </div>
// <p className="income-subtitle">Income Per Month</p>


// <div className="form-group-container">


// <div className="income-label-container">
// <label className="form-label form-label-income">Enter your Income</label>
// </div>
// <div className="cost-input-wrapper">
// <span className="currency-symbol">₹</span>
// <input
// type="text"
// className="cost-input"
// placeholder="10,000"
// value={formatIndianNumber(monthlyIncome)}
// onChange={(e) => handleMonthlyIncomeChange(e.target.value)}
// inputMode="numeric"
// pattern="[0-9]*"
// />
// </div>
// </div>
// </div>
// </div>
// </div>
// </div>


// {/* Error Message */}
// {apiError && (
// <div className="error-message" style={{
// color: "#ff4444",
// textAlign: "center",
// padding: "16px",
// marginBottom: "16px",
// backgroundColor: "#ffe6e6",
// borderRadius: "8px",
// margin: "0 16px"
// }}>
// {apiError}
// </div>
// )}


// <div className="fixed-button-container">
// <button
// className="continue-button"
// onClick={handleContinue}
// disabled={!isFormValid || isLoading}
// >
// {isLoading ? "SUBMITTING..." : "CONTINUE"}
// </button>
// </div>


// </div>
// </>
// );
// };


// export default EmploymentDetails;

























import React, { useState, useEffect } from "react";
import useRouting from "../hooks/useRouting";
import usePageTracking from "../hooks/usePageTracking";
import { trackEvent } from "../utils/trackEvent";
import environment from "../environment";
import axios from "axios";
//import Swal from "sweetalert2";
import { getHeaders, getStorage, handleApiError } from "../utils/apiUtils";
import Header from "./Header";
import LenderLoadingScreen from "./LenderLoadingScreen";
import "./EmploymentDetails.css";
import employment_Detail from "../assets/images/employment_Detail.svg";

const capitalizeWord = (value = "") =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "";

const formatIndianNumber = (value = "") => {
  if (!value) return "";
  const numberValue = Number(value);
  if (Number.isNaN(numberValue)) return "";
  // eslint-disable-next-line no-undef
  return new Intl.NumberFormat("en-IN").format(numberValue);
};

const EmploymentDetails = () => {
  // Company Details State
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [addressLine, setAddressLine] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [pincodeStatus, setPincodeStatus] = useState("");

  // Employment Details State
  const [employmentType, setEmploymentType] = useState("");

  // Income Details State
  const [incomeType, setIncomeType] = useState("");
  const [monthlyIncome, setMonthlyIncome] = useState("");

  // Loading and error states
  const [isLoading, setIsLoading] = useState(false);
  const [isLenderLoading, setIsLenderLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  //const [sendOrAssignLenderFailed, setSendOrAssignLenderFailed] = useState(false);
  //const [treatmentDetails, setTreatmentDetails] = useState(true);
  //const [lenderDetail, setLenderDetail] = useState(null);

  const { navigateWithContext, navigateBack } = useRouting();
  
  // Track page visit
  usePageTracking("employment-details");
  useEffect(() => { trackEvent("loan_employment_details_viewed"); }, []);

  useEffect(() => {
    fetchEmploymentDetails();
    //assignLender();
  }, []);

  // Watch for pin code changes and auto-fill state/city
  useEffect(() => {
    const fetchLocation = async () => {
      if (pinCode && pinCode.length === 6) {
        setPincodeStatus("Please wait fetching state & city ...");
        const locationData = await fetchLocationFromPinCode(pinCode);
        if (locationData) {
          setState(capitalizeWord(locationData.state));
          setCity(capitalizeWord(locationData.city));
          setArea(capitalizeWord(locationData.area));
          setPincodeStatus("");
        } else {
          setPincodeStatus("Failed to fetch city/state");
        }
      } else {
        setState("");
        setCity("");
        setPincodeStatus("");
      }
    };

    // Debounce the API call to avoid too many requests
    const timeoutId = setTimeout(fetchLocation, 500);
    return () => clearTimeout(timeoutId);
  }, [pinCode]);

  // Fetch employment details to prefill form
  const fetchEmploymentDetails = async () => {
    try {
      const applicationId = getStorage("application_id");
      if (!applicationId) {
        console.error("Application ID not found in localStorage");
        return;
      }

      const endpoint = `${environment.apiurl}applications/${applicationId}/employment_details/`;
      const response = await axios.get(endpoint, { headers: getHeaders() });
      
      if (response?.data?.msg) {
        const employmentData = response.data.msg;
        
        // Prefill company details
        if (employmentData.company_name) setCompanyName(employmentData.company_name);
        if (employmentData.employment_type) setEmploymentType(employmentData.employment_type.toLowerCase());
        if (employmentData.monthly_income) setMonthlyIncome(employmentData.monthly_income.toString());
        if (employmentData.medium_of_salary) setIncomeType(employmentData.medium_of_salary.toLowerCase());
        
        // Prefill company address if available
          if (employmentData.address_line_1) setAddress(employmentData.address_line_1);
          if (employmentData.address_line_2) setAddressLine(employmentData.address_line_2);
          if (employmentData.area) setArea(employmentData.area.toLowerCase());
          if (employmentData.pincode) setPinCode(employmentData.pincode);
          if (employmentData.city) setCity(capitalizeWord(employmentData.city));
          if (employmentData.state) setState(capitalizeWord(employmentData.state));
      }
    } catch (error) {
      console.error("Error fetching employment details:", error);
      // Don't show error to user for prefill failures
    }
  };

  // Helper function to check if API response indicates an error
  const checkApiError = (response) => {
    if (!response?.data) return null;
    
    const { msg, metadata } = response.data;
    
    // Check for api_status: false
    if (metadata?.api_status === false) {
      return msg?.message || msg?.data?.message || "An error occurred";
    }
    
    // Check for status: "error" with code 100
    if (msg?.status === "error" && msg?.code === 100) {
      return msg?.message || "An error occurred";
    }
    
    // Check for error in msg.data
    if (msg?.data?.status === "error" && msg?.data?.code === 100) {
      return msg?.data?.message || msg?.message || "An error occurred";
    }
    
    return null;
  };

  // Helper function to navigate to error page
  const navigateToErrorPage = (errorMessage) => {
    // Store error message in localStorage
    localStorage.setItem("errorMessage", errorMessage);
    // Navigate to error page
    navigateWithContext("error");
  };

  // Assign lender API call
  const assignLender = async () => {
    try {
      const applicationId = getStorage("application_id");
      if (!applicationId) {
        console.error("Application ID not found in localStorage");
        return;
      }

      const payload = {
        data: "",
      };

      const response = await axios.post(
        `${environment.apiurl}applications/${applicationId}/assign_lender/`,
        payload,
        { headers: getHeaders() }
      );

      // Check for API error in response
      const errorMessage = checkApiError(response);
      if (errorMessage) {
        setIsLenderLoading(false);
        navigateToErrorPage(errorMessage);
        return;
      }

      if (response?.data?.msg) {
       // setLenderDetail(response.data.msg);
        localStorage.setItem(
          "lenderDetail",
          JSON.stringify(response.data.msg?.lender)
        );
        console.log('response.data.msg', response.data.msg)
        await sendToLenderCall();

      }
    } catch (err) {
      console.error("Error in assignLender:", err);
      
      // Check if error response contains error message
      const errorMessage = checkApiError(err.response);
      if (errorMessage) {
        setIsLenderLoading(false);
        navigateToErrorPage(errorMessage);
        return;
      }
      
      // Fallback error message
      const fallbackMessage = err?.response?.data?.msg?.message || 
                             err?.response?.data?.msg?.data?.message ||
                             "An error occurred while assigning a lender. Please try again later.";
      setIsLenderLoading(false);
      navigateToErrorPage(fallbackMessage);
    }
  };

  // API call to submit employment details
  const submitEmploymentDetails = async () => {
    const applicationId = getStorage("application_id");
    if (!applicationId) {
      throw new Error("Application ID not found");
    }

    const payload = {
      data: [
        {
          model_name: "personal_company_address",
          field: [
            {
              key: "address_line_1",
              value: address,
            },
            {
              key: "address_line_2",
              value: addressLine,
            },
            {
              key: "landmark",
              value: area,
            },
            {
              key: "pincode",
              value: pinCode,
            },
            {
              key: "city",
              value: city,
            },
            {
              key: "state",
              value: state,
            },
          ],
        },
        {
          model_name: "personal",
          field: [
            {
              key: "company_name",
              value: companyName,
            },
            {
              key: "employment_type",
              value: employmentType,
            },
            {
              key: "monthly_income",
              value: parseInt(monthlyIncome) || 0,
            },
            {
              key: "medium_of_salary",
              value: incomeType,
            },
          ],
        },
      ],
    };

    const response = await axios.post(
      `${environment.apiurl}applications/${applicationId}/save/data/`,
      payload,
      { headers: getHeaders() }
    );
    assignLender();

    return response.data;
  };

  // Send to lender API call
  // const sendToLenderCall = async () => {
  //   setIsLenderLoading(true);
    
  //   // Set a timeout to automatically turn off loading after 10 seconds
  //   const loadingTimeout = setTimeout(() => {
  //     setIsLenderLoading(false);
  //   }, 10000);
    
  //   try {
  //     const applicationId = getStorage("application_id");
  //     if (!applicationId) {
  //       clearTimeout(loadingTimeout); // Clear the timeout if there's an error
  //       throw new Error("Application ID not found");
  //     }

  //     const payload = {
  //       data: "",
  //     };

  //     const response = await axios.post(
  //       `${environment.apiurl}applications/${applicationId}/send_to_lender/`,
  //       payload,
  //       { headers: getHeaders() }
  //     );

  //     console.log(response);
  //     setIsLenderLoading(false);
  //     navigateWithContext("lender-success");
      
  //     if (response?.data?.msg?.url) {
  //       // If URL is provided, redirect to external URL
  //       localStorage.setItem("redirectURL", response.data.msg.url)
  //     } 
       
      
  //   } catch (error) {
  //     console.error("Error sending to lender:", error);
  //     clearTimeout(loadingTimeout); // Clear the timeout in case of error
  //     setIsLenderLoading(false);
  //     setApiError("Failed to send application to lender");
      
  //     if (error?.response?.data?.msg?.data?.code === 100) {
  //       setIsLoading(false);
  //       setTreatmentDetails(false);
  //       setSendOrAssignLenderFailed(true);
  //     } else {
  //       setTreatmentDetails(true);
  //       setIsLoading(false);
  //     }
  //     throw error;
  //   }
  // };


  // Send to lender API call
const sendToLenderCall = async () => {
  setIsLenderLoading(true);

  const start = Date.now(); // Start 10-sec timer here

  try {
    const applicationId = getStorage("application_id");
    if (!applicationId) {
      throw new Error("Application ID not found");
    }

    const payload = {
      data: "",
    };  

    // Actual API call
    const response = await axios.post(
      `${environment.apiurl}applications/${applicationId}/send_to_lender/`,
      payload,
      { headers: getHeaders() }
    );

    console.log(response);

    // Check for API error in response
    const errorMessage = checkApiError(response);
    if (errorMessage) {
      const elapsed = Date.now() - start;
      const remaining = 10000 - elapsed;
      
      setTimeout(() => {
        setIsLenderLoading(false);
        navigateToErrorPage(errorMessage);
      }, remaining > 0 ? remaining : 0);
      return;
    }

    // Calculate remaining time to complete 10 seconds
    const elapsed = Date.now() - start;
    const remaining = 10000 - elapsed;

    // Always wait full 10 sec before moving ahead
    setTimeout(() => {
      setIsLenderLoading(false);

      // Navigate AFTER loader hides
      navigateWithContext("lender-success");

      if (response?.data?.msg?.url) {
        localStorage.setItem("redirectURL", response.data.msg.url);
      }
    }, remaining > 0 ? remaining : 0);

  } catch (error) {
    console.error("Error sending to lender:", error);

    const elapsed = Date.now() - start;
    const remaining = 10000 - elapsed;

    // Check if error response contains error message
    const errorMessage = checkApiError(error.response);
    const finalErrorMessage = errorMessage || 
                             error?.response?.data?.msg?.message ||
                             error?.response?.data?.msg?.data?.message ||
                             "Failed to send application to lender";

    // Even on error, keep loader for full 10 seconds
    setTimeout(() => {
      setIsLenderLoading(false);
      navigateToErrorPage(finalErrorMessage);
    }, remaining > 0 ? remaining : 0);
  }
};


  const handleContinue = async () => {
    trackEvent("loan_employment_details_continue_clicked", {
      employment_type: employmentType,
      income_type: incomeType,
    });
    const employmentData = {
      companyDetails: {
        name: companyName,
        address: address,
        addressLine: addressLine,
        pinCode: pinCode,
        state: state,
        city: city,
        area: area,
      },
      employmentDetails: {
        type: employmentType,
      },
      incomeDetails: {
        type: incomeType,
        monthlyIncome: monthlyIncome,
      },
    };

    const isCompanyDetailsValid = companyName && address && pinCode && state && city && area;
    const isEmploymentDetailsValid = employmentType;
    const isIncomeDetailsValid = incomeType && monthlyIncome;

    if (isCompanyDetailsValid && isEmploymentDetailsValid && isIncomeDetailsValid) {
      setIsLoading(true);
      setApiError("");

      try {
        // Submit employment details to API
        await submitEmploymentDetails();

        // Save to localStorage after successful API call
        localStorage.setItem("employmentDetails", JSON.stringify(employmentData));
        
        // Call sendToLenderCall after successful employment details submission
        
      } catch (error) {
        console.error("Error submitting employment details:", error);
        const errorMessage = handleApiError(error);
        setApiError(errorMessage);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleBack = () => {
    // Use new routing
    navigateBack("address-details");
  };

  const handleMonthlyIncomeChange = (value) => {
    const sanitizedValue = value.replace(/\D/g, "");
    setMonthlyIncome(sanitizedValue);
  };

  // Function to fetch location data from postal API
  // const fetchLocationFromPinCode = async (pinCode) => {
  //   if (!pinCode || pinCode.length !== 6) {
  //     return {
  //       state: "",
  //       city: "",
  //       area: "",
  //     };
  //   }
  //   try {
  //     const response = await axios.get(
  //       `https://api.postalpincode.in/pincode/${pinCode}`
  //     );

  //     if (
  //       response.data &&
  //       response.data[0] &&
  //       response.data[0].Status === "Success"
  //     ) {
  //       const postOffices = response.data[0].PostOffice;
  //       if (postOffices && postOffices.length > 0) {
  //         const firstOffice = postOffices[0];
  //         return {
  //           state: firstOffice.State,
  //           city: firstOffice.District,
  //         };
  //       }
  //     } else {
  //       return {
  //         state: "",
  //         city: "",
  //       };
  //     }
  //   } catch (error) {
  //     console.error("Error fetching location from pin code:", error);
  //     return null;
  //   }
  // };


  const fetchLocationFromPinCode = async (pinCode) => {
    if (!pinCode || pinCode.length !== 6) {
      return { state: "", city: "", area: "" };
    }

    try {
      const response = await axios.get(
        `${environment.apiurlv3_webapi}v4/pincode/detail/?pincode=${pinCode}`
      );

      const msg = response.data?.msg;
      if (msg && response.data?.metadata?.api_status === true) {
        const locations = msg.locations || [];
        const first = locations[0] || {};
        // district → city, city → area/locality, state → state
        return {
          state: first.state || "",
          city: first.district || "",
          area: first.city || "",
        };
      }

      return { state: "", city: "", area: "" };
    } catch (error) {
      return { state: "", city: "", area: "" };
    }
  };

  const employmentTypes = [{key :"Salaried", value: "s"}, { key :"Self Employed" , value: "e"}, { key :"Business Owner", value: "b"}, { key :"Freelancer", value: "f"}];
  const incomeTypes = [{key :"Bank Account", value: "received_in_bank_account"}, { key :"Cash" , value: "cash"}, { key :"Cheque", value: "cheque"}, { key :"Online Transfer", value: "ot"}];

  const isFormValid = 
    companyName && address && pinCode && state && city && area &&
    employmentType && incomeType && monthlyIncome;

  return (
    <>
      {/* Show lender loading screen when sending to lender */}
      {isLenderLoading && <LenderLoadingScreen />}
      
    <div className="loan-container">
      <Header showBackButton={true} onBackClick={handleBack} />

      <div className="main-content">
        <div className="hero-section">
          <div className="hero-icon">
            <img src={employment_Detail} alt="Employment Details" />
          </div>
          <h1 className="hero-title">
            Please share your
            <br />
            employment details
          </h1>
        </div>

        <div className="form-section">
          {/* Company Details Section */}
          <div className="employment-detail-container">
            <h2 className="section-title">Company Details</h2>
            <div className="employment-detail-form-group">
              <div className="form-group-container">
                <label className="form-label">Company Name <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="ABC Pvt. Ltd."
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>

              <div className="form-group-container">
                <label className="form-label">Address <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Building Name"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>

              <div className="form-group-container">
                <label className="form-label">Address 1</label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Address Line 2"
                  value={addressLine}
                  onChange={(e) => setAddressLine(e.target.value)}
                />
              </div>

              <div className="form-group-container">
                <label className="form-label">Pin Code <span className="text-red-500">*</span></label>
                <div className="pincode-input-container">
                  <input
                    type="text"
                    className="form-input"
                    placeholder="400001"
                    value={pinCode}
                    onChange={(e) => {
                      const val = e.target.value;
                      setPinCode(val);
                      if (val.length !== 6) {
                        setPincodeStatus("");
                      }
                    }}
                    maxLength={6}
                  />
                  {pincodeStatus && (
                    <p
                      style={{
                        color: "#216fed",
                        fontSize: "12px",
                        marginTop: "4px",
                        textAlign: "left",
                        alignSelf: "flex-start",
                      }}
                    >
                      {pincodeStatus}
                    </p>
                  )}
                </div>
              </div>

              <div className="form-group-container">
                <label className="form-label">State <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="State"
                  value={state}
                  onChange={(e) => setState(capitalizeWord(e.target.value))}
                />
              </div>

              <div className="form-group-container">
                <label className="form-label">City <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(capitalizeWord(e.target.value))}
                />
              </div>

              <div className="form-group-container">
                <label className="form-label">Area, Locality <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Area"
                  value={area}
                 onChange={(e) => setArea(capitalizeWord(e.target.value))}

                />
              </div>
            </div>
          </div>

          {/* Employment Details Section */}
          <div className="employment-detail-container">
            <h2 className="section-title">Employment Details</h2>
            <div className="employment-detail-form-group">
              <div className="form-group-container">
                <label className="form-label">Employment Type <span className="text-red-500">*</span></label>
                <select
                  className="form-select"
                  value={employmentType}
                  onChange={(e) => setEmploymentType(e.target.value)}
                >
                  <option value="">Select Employment Type</option>
                  {employmentTypes.map((type, index) => (
                    <option key={index} value={type.value}>
                      {type.key}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Income Details Section */}
          <div className="employment-detail-container">
            <h2 className="section-title" style={{ color: "#4A90E2", marginBottom: "16px" }}>Income Details</h2>
            <div className="employment-detail-form-group">
              <div className="form-group-container">
                <label className="form-label">Salary credited in <span className="text-red-500">*</span></label>
                <select
                  className="form-select"
                  value={incomeType}
                  onChange={(e) => setIncomeType(e.target.value)}
                >
                  <option value="">Select Income Type</option>
                  {incomeTypes.map((type, index) => (
                    <option key={index} value={type.value}>
                      {type.key}
                    </option>
                  ))}
                </select>
              </div>
              <p className="income-subtitle">Income Per Month</p>

              <div className="form-group-container">

                <div className="income-label-container">
                  <label className="form-label form-label-income">Enter your Income</label>
                </div>
                <div className="cost-input-wrapper">
                    <span className="currency-symbol">₹</span>
                <input
                  type="text"
                 className="cost-input"
                  placeholder="10,000"
                  value={formatIndianNumber(monthlyIncome)}
                  onChange={(e) => handleMonthlyIncomeChange(e.target.value)}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {apiError && (
        <div className="error-message" style={{ 
          color: "#ff4444", 
          textAlign: "center", 
          padding: "16px", 
          marginBottom: "16px",
          backgroundColor: "#ffe6e6",
          borderRadius: "8px",
          margin: "0 16px"
        }}>
          {apiError}
        </div>
      )}

      <div className="fixed-button-container">
        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={!isFormValid || isLoading}
        >
          {isLoading ? "SUBMITTING..." : "CONTINUE"}
        </button>
      </div>

    </div>
    </>
  );
};

export default EmploymentDetails;